import React from 'react';

import { handleFieldChange } from "../../../../Utils";
import { Button } from 'react-bootstrap';

import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.props.partner ? this.props.partner : {
            name: '',
            costCalculationMethod: 'default',
            partnerDomainType: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ minHeight: '300px', height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />

                    <SelectWrap
                        values={[ 'default', 'ours', 'theirs' ]}
                        label="Cost Calculation Method:"
                        name="costCalculationMethod"
                        onChange={this.handleFieldChange}
                        value={this.state.costCalculationMethod}
                        required
                    />

                    <SelectWrap
                        values={this.props.adk_partner_domains.map(({ type }) => type)}
                        label="Partner Domain Type:"
                        name="partnerDomainType"
                        onChange={this.handleFieldChange}
                        value={this.state.partnerDomainType}
                    />

                    <Button className="pull-right" bsStyle="success" type="submit">Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartners/components/Form/index.js